// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/css/transitions.scss"],"names":[],"mappings":"AAAA;EACC,wBAAA;AACD;;AACA;EACC,UAAA;AAED","sourcesContent":[".fade-enter-active, .fade-leave-active {\n\ttransition: opacity .5s\n}\n.fade-enter, .fade-leave-to {\n\topacity: 0\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
